module.exports = __webpack_public_path__ + "b0d8ead579c38eb4c471bf08c672f978.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_1-420.webp.png
// module id = 568
// module chunks = 0